module.exports = __webpack_public_path__ + "img/blue_blur.65847d28.png";